import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconParachute: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="parachute, airdrop"><rect x="9.75" y="16.75" width="4.5" height="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M22 12.75C22 7.22715 17.5228 2.75 12 2.75C6.47715 2.75 2 7.22715 2 12.75M22 12.75C18.5666 10.3797 15.2833 9.19449 12 9.19449M22 12.75L14.6968 18.1057M2 12.75C5.4334 10.3797 8.7167 9.19449 12 9.19449M2 12.75L9.30322 18.1057M12 9.19449V16.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconParachute;
